import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class EventHandlingService {
  constructor() {}
  public _actiontemSource = new BehaviorSubject<any>({});
  public _isLiveSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public _isAuthSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public _showNav: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  public _changeClassStatus: BehaviorSubject<string> =
    new BehaviorSubject<string>('');
  public _liveClassData = new BehaviorSubject<any>(null);
  public _liveClassAction = new BehaviorSubject<any>(null);
  public _userLogOutAction = new BehaviorSubject<any>(null);
  public genWizUrl = new BehaviorSubject<any>(null);
  genWizUrl$ = this.genWizUrl.asObservable();
  actionItem$ = this._actiontemSource.asObservable();
  isLiveStatus$ = this._isLiveSource.asObservable();
  isAuthStatus$ = this._isAuthSource.asObservable();
  changeClassStatus$ = this._changeClassStatus.asObservable();
  liveClassData$ = this._liveClassData.asObservable();
  liveClassAction$ = this._liveClassAction.asObservable();
  userLogOutAction$ = this._userLogOutAction.asObservable();
  public changeFocusedExamFromHeader = new BehaviorSubject<any>({});
  headerFocusedExamChanged = this.changeFocusedExamFromHeader.asObservable();
  public classEndCheck = new BehaviorSubject<any>({});
  checkClassEnd = this.classEndCheck.asObservable();
  public refreshCourseClass = new BehaviorSubject<boolean>(false);
  courseClassRefresh = this.refreshCourseClass.asObservable();
  // service command
  showLogoPopup = new BehaviorSubject<boolean>(false);
  logoPopup = this.showLogoPopup.asObservable();
  showNav(data: boolean) {
    this._showNav.next(data);
  }

  getShowNavObs(): Observable<boolean> {
    return this._showNav.asObservable();
  }

  setShowNavObs(nav: boolean) {
    this._showNav.next(nav);
  }

  // service command
  changeAction(data: any) {
    this._actiontemSource.next(data);
  }

  getChangeAction(): Observable<any> {
    return this._actiontemSource.asObservable();
  }

  updateChangeAction(data: any) {
    this._actiontemSource.next(data);
  }
  changeisLiveStatus(isLive: boolean) {
    this._actiontemSource.next(isLive);
  }
  changeClassStatus(data: string) {
    this._changeClassStatus.next(data);
  }

  getChangeClassStatus(): Observable<any> {
    return this._changeClassStatus.asObservable();
  }

  public isAuthenticated() {
    const token: any = localStorage.getItem('token');
    this._isAuthSource.next(token !== null ? true : false);
  }

  updateLiveClassData(data: any) {
    this._liveClassData.next(data);
  }

  updateAuthStatus(status: boolean): void {
    this._isAuthSource.next(status);
  }

  liveClassAction = (data: any) => {
    this._liveClassAction.next(data);
  };

  userLogOutAction = (data: any = null) => {
    this._userLogOutAction.next(data);
  };

  redirectToWiz = (data: any) => {
    this.genWizUrl.next(data);
  };
}
